<div *ngIf="isLoggedIn$ | async; else loggedOut">
 
  
  <router-outlet></router-outlet>
  
</div>

<ng-template #loggedOut>
  <app-auth-page></app-auth-page>
</ng-template>

